import { overrideConfirmCopy } from '@features/feature-flags';

/**
 * The typed confirmation of every turn-off (ACR-1598, design M12), as plain data
 * for the reason `component-card.ts` gives.
 */

export const TURN_OFF_PHRASE = 'I understand the consequences';

/** Exact and case-sensitive, and it does not trim: a trailing space is a different text. */
export function matchesPhrase(text: string): boolean {
    return text === TURN_OFF_PHRASE;
}

export interface TurnOffAlert {
    /** One sentence: how many flags and which scope. Never names a flag; the page lists them. */
    readonly sentence: string;
    /** One per Salesforce-type flag, worded as the first-override confirmation words it. */
    readonly salesforceNotes: readonly string[];
}

function plural(count: number, one: string, many: string): string {
    return `${String(count)} ${count === 1 ? one : many}`;
}

export function turnOffAlert(input: {
    readonly scope: 'all' | 'clients';
    readonly flagCount: number;
    /** Specific clients only. */
    readonly clientCount?: number;
    readonly salesforceFlags: readonly {
        readonly key: string;
        readonly salesforceField?: string | undefined;
    }[];
}): TurnOffAlert {
    const flags = plural(input.flagCount, 'flag', 'flags');
    const target =
        input.scope === 'all' ? 'all clients' : plural(input.clientCount ?? 0, 'client', 'clients');
    // The wording is per org there; a release turn-off spans orgs, so it names the scope instead.
    const org = input.scope === 'all' ? 'every client' : 'each selected client';

    return {
        sentence: `This turns off ${flags} for ${target}.`,
        salesforceNotes: input.salesforceFlags.map(
            (flag) =>
                overrideConfirmCopy(
                    flag.key,
                    { type: 'salesforce', salesforceField: flag.salesforceField },
                    { tenantId: org, enabled: false },
                ).description,
        ),
    };
}
